// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","inner":"Footer_inner__QWbCb","left":"Footer_left__uf-wb","right":"Footer_right__rtqAj"};